// extracted by mini-css-extract-plugin
export default {"footerSection":"Footer_footerSection__SDHIS","line":"Footer_line__JgfiF","footerContent":"Footer_footerContent__391Xf","footerIcon":"Footer_footerIcon__JYZm5"};